import * as ActionTypes from 'constants';
import moment from 'moment';

const default_selected_columns =
	JSON.parse(localStorage.getItem('clients.selected_columns')) ||
	[
		'name',
		'phone',
		'email',
		'address.street',
		'address.city',
		'address.state',
		'address.zip',
		'last_impact_report.map_properties.storm_date',
		'last_impact_report.feature_properties',
		'address.geocoded'
	];

export const clients = (state = {
	clients_table_list: [],
	clients_map_list: [],
	viewing_clients_map: false,
	show_client_modal: false,
	tmp_client: null,
  selected_client_id: null,
	downloading_client_report: false,
	creating_client: false,
	show_create_client: false,
	current_place: null,
	selecting_columns: false,
	selected_columns: default_selected_columns || [], //default_selected_columns,
	loading: false,
	error: null,
	fetching_clients: false,
  fetching_client: false,
	filters: [],
	bounds: null,
	filter_table_by_map_bounds: localStorage && localStorage.getItem('filter_clients_by_map_bounds') == 'false' ? false : true,
	clients_table_open_state: 'closed',
	sort_column: 'name',
	total: 0,
	offset: 0,
	size: localStorage ? Number(localStorage.getItem('clients_table_page_size')) : 20, //Arbitrary limit.
}, action) => {
	const { type, payload } = action;
	switch(type) {
		case ActionTypes.SHOW_CREATE_CLIENT:
			return {...state, show_create_client: true, tmp_client: payload || null};
		case ActionTypes.HIDE_CREATE_CLIENT:
			return {...state, show_create_client: false, tmp_client: null};
		case ActionTypes.UPDATE_CURRENT_PLACE:
			return {...state, current_place: payload}
		case ActionTypes.DOWNLOADING_CLIENT_REPORT:
			return {...state, downloading_client_report: action.payload}
		case ActionTypes.ADD_CLIENT:
			return {
				...state,
				clients_table_list: [ ...state.clients_table_list, action.client ],
				clients_map_list: state.viewing_clients_map ? [ ...state.clients_map_list, action.client ] : state.clients_map_list
			}
    case ActionTypes.SELECT_CLIENT:
      return {
        ...state,
        selected_client_id: payload.id || payload.client_id || payload._id, //Gives options for payload.
      }
		case ActionTypes.DELETE_CLIENT:
			const { id } = action;
			return {
				...state,
				clients_table_list: state.clients_table_list.filter(c => c._id != id),
				clients_map_list: state.clients_map_list.filter(c => c._id != id)
			}
		case ActionTypes.UPDATE_CLIENTS:
			return {
				...state,
				clients_table_list: action.clients,
				clients_map_list: state.viewing_clients_map ? action.clients : state.clients_map_list
			}
		case ActionTypes.ADD_CLIENT_ERROR:
			return Object.assign({}, state, {error: action.error});
		case ActionTypes.UPDATE_CLIENT:
			const { client } = action;
			return {
				...state,
				clients_table_list: state.clients_table_list.map(c => c._id == client._id ? client : c),
				clients_map_list: state.viewing_clients_map ? state.clients_map_list.map(c => c._id == client._id ? client : c) : state.clients_map_list
			}
		case ActionTypes.CLEAR_CLIENTS:
			return {
				...state,
				clients_table_list: [],
				clients_map_list: []
			}
		case ActionTypes.SET_CLIENT_PAGE_SIZE:
			return {
				...state,
				page_size: payload.size || 20
			}
		case ActionTypes.SET_CLIENT_SORT_COLUMN:
			return {
				...state,
				sort_column: payload.column
			}
    case ActionTypes.ADD_CLIENTS_FILTER:
      return {
        ...state,
				filters: [ ...state.filters, payload.filter ]
      }
    case ActionTypes.SET_CLIENTS_FILTERS:
      return {
        ...state,
        filters: payload.options.filters || payload.options.filters || [],
        bounds: payload.options.bounds,
      }
    case ActionTypes.UPDATE_CLIENTS_BOUNDS:
      return {
        ...state,
        bounds: payload,
      }
		case ActionTypes.FETCH_CLIENTS_FILTERS:
			return {
				...state,
				fetching_filters: true,
			}
    case ActionTypes.CLEAR_FETCHED_CLIENTS_FILTERS:
      return {
        ...state,
        filters : []
      }
		case ActionTypes.FETCH_CLIENTS_WITH_FILTERS:
			return {
				...state,
				filters: payload.options.filters
			}
		case ActionTypes.FETCH_CLIENTS_SUCCEEDED:
			return {
				...state,
				clients_table_list: payload.clients_table_list,
				clients_map_list: payload.clients_map_list || [],
				total: payload.total || 0,
				offset: payload.offset || 0,
				size: payload.size || 10,
				fetching_clients: false
			}
    case ActionTypes.FETCH_CLIENT:
        return {
          ...state,
          fetching_client: true
        }
    case ActionTypes.RECEIVE_CLIENT:
      return {
        ...state,
				clients_table_list: [ ...state.clients_table_list.filter(client => client._id != payload._id), payload ],
				clients_map_list: state.viewing_clients_map ? [ ...state.clients_map_list.filter(client => client._id != payload._id), payload ] : state.clients_map_list,
        fetching_client: false
      }
		case ActionTypes.FETCH_CLIENT_FAILED:
			return {
				...state,
				fetching_client: false
			}
		case ActionTypes.SHOW_SELECTING_CLIENT_COLUMNS:
			return {
				...state,
				selecting_columns: true,
			}
		case ActionTypes.HIDE_SELECTING_CLIENT_COLUMNS:
			return {
				...state,
				selecting_columns: false,
			}
		case ActionTypes.TOGGLE_CLIENT_COLUMN:
			let selected_columns = state.selected_columns.find(column => column == action.payload.column) ?
				[ ...state.selected_columns.filter((column) => (column != action.payload.column)) ] :
				[ ...state.selected_columns, action.payload.column ];
			if(localStorage) {
				localStorage.setItem('clients.selected_columns', JSON.stringify(selected_columns));
			}
			return {
				...state,
				selected_columns
			}
		case ActionTypes.SET_CLIENT_COLUMNS:
			return {...state, selected_columns: payload}
		case ActionTypes.TOGGLE_FETCHING_CLIENT:
			return {...state, fetching_client: payload != null ? payload : !state.fetching_client}
		case ActionTypes.TOGGLE_FETCHING_CLIENTS:
			return { ...state, fetching_clients: payload != null ? payload: !state.fetching_clients };
		case ActionTypes.TOGGLE_FILTER_CLIENTS_TABLE_BY_MAP_BOUNDS:
			return { ...state, filter_table_by_map_bounds: payload != null ? payload: !state.filter_table_by_map_bounds };
		case ActionTypes.TOGGLE_VIEWING_CLIENTS_MAP:
			const viewing_map = payload != null ? payload : !state.viewing_clients_map;
			return {
				...state,
				viewing_clients_map: viewing_map,
				size: viewing_map ? 5 : state.size		// side effect of having a smaller table size when in map view
			};
		case ActionTypes.UPDATE_CLIENTS_TABLE_OPEN_STATE:
			return { ...state, clients_table_open_state: payload };
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/common/reducers/clients.js